import { State } from '../types';

export const INITIAL_STATE: State = {
  mode: 'dark',
};
